import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SearchBarComponent } from './search-bar.component';
import { FrontendIconsModule } from '@tablesready/frontend-icons';

@NgModule({
  declarations: [SearchBarComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FrontendIconsModule,
  ],
  exports: [SearchBarComponent],
})
export class SearchBarModule { }
